module.exports = __webpack_public_path__ + "img/user-qy-avatar.e7aaf55c.png";